module.exports = __webpack_public_path__ + "static/img/f3.daa0fbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/f3.png
// module id = QKUp
// module chunks = 0